const roles = {
  legal: 'Legal Rep',
  admin: 'Super Admin',
  user: 'Competition Owner',
  superadmin: 'Root'
}
const roleMapper = function (role) {
  return roles[role]
}

export { roleMapper }



// WEBPACK FOOTER //
// ./src/helpers/users.js